var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-9136076486841527"},[_c('a',{attrs:{"target":"_new_page","href":"https://github.com/Kchengz/k-form-design"}},[_vm._v("k-form-design")])])
}]

export { render, staticRenderFns }